







































import Vue from "vue";
import { mapState, mapActions } from "vuex";
import store from "../store/index";

export default Vue.extend({
  name: "OriginalTextMark",
  computed: mapState({
    reportType: (state: any) => store.getters.getReportType,
    checkInfo: (state: any) => store.getters.getCheckInfo,
    checkText: (state: any) => store.getters.getCheckText,
    productId: (state: any) => store.getters.getProductId,
  }),
  watch: {
    checkInfo(newVal, oldVal) {
      this.initOriginalTextMark();
    },
    checkText(newVal, oldVal) {
      this.initOriginalTextMark();
    },
  },
  data() {
    return {
      checkTextStr: "",
    };
  },
  methods: {
    // 标记字的索引信息转成段落
    divideSection(list: number[]) {
      const section: any = [];
      list.forEach((item: number, index: number) => {
        if (
          section.length &&
          list[index] - section[section.length - 1].beginIndex === 1
        ) {
          section[section.length - 1].beginIndex = list[index];
          section[section.length - 1].length = section[section.length - 1].length + 1;
        } else {
          section.push({
            beginIndex: list[index],
            begin: list[index],
            length: 1,
          });
        }
      });
      return section;
    },
    // 初始化原文
    initOriginalTextMark() {
      let checkText = this.checkText || "";
      const problemList = this.checkInfo.hitDetailInfoList || [];
      if (
        this.productId == "HD" &&
        this.checkInfo.rootobject &&
        this.checkInfo.rootobject.tables &&
        this.checkInfo.rootobject.tables.length > 0
      ) {
        checkText = this.checkInfo.rootobject.text;
      }

      // 报告字符串转换成数组
      let checkTextArry = checkText.split("");
      // console.log(checkTextArry);

      // this.checkTextStr = "";
      // 偏移量
      let offset = 0;

      checkTextArry = checkTextArry.map((item: any) => {
        return item.replace(/</gi, "＜").replace(/>/gi, "＞");
      });

      // problemList.forEach((item: any, index: number) => {
      //   let hitText = checkText.substr(item.beginPosition, item.length) || "";
      //   // 标注颜色
      //   let eClass = "red border-b-red";
      //   // 根据不同的状态显示不同的颜色
      //   if (item.isSelfCited) {
      //     eClass = "yellow border-b-yellow";
      //   } else if (item.isReference) {
      //     eClass = "green border-b-green";
      //   } else if (item.isLaw) {
      //     eClass = "deepblue border-b-deepblue";
      //   }

      //   const section = this.divideSection(item.originalChars);
      //   // 按字标记
      //   let hitStr = "";
      //   let flag = false;
      //   const hitTextArry = hitText.split("");
      //   hitTextArry.forEach((items: any, index: number) => {
      //     if (item.originalChars.indexOf(item.beginPosition + index) != -1) {
      //       if (flag) {
      //         hitStr += items;
      //       } else {
      //         hitStr += `<span data-index="${index}" class="${eClass}">${items}`;
      //         flag = true;
      //       }
      //     } else {
      //       if (flag) {
      //         hitStr += `</span>${items}`;
      //         flag = false;
      //       } else {
      //         hitStr += items;
      //       }
      //     }
      //   });

      //   // let hitOffset = 0;
      //   // section.forEach((items: any) => {
      //   //   const hitWord = hitText.substr(items.begin - item.beginPosition - hitOffset, items.length);
      //   //   hitTextArry.splice(items.begin - item.beginPosition - hitOffset, items.length, `<span data-index=${index} class="${eClass}">${hitWord}</span>`);
      //   //   // 按字标的偏移量
      //   //   hitOffset = hitOffset + items.length - 1;
      //   // });
      //   // hitText = hitTextArry.join('');

      //   // 根据位置替换相似片段
      //   checkTextArry.splice(
      //     item.beginPosition - offset,
      //     item.length,
      //     `<span data-index=${index} id="vecFragment${index}" e-type="section">${hitStr}</span>`
      //   );
      //   // 报告数组的偏移量
      //   offset = offset + item.length - 1;
      // });

      this.checkTextStr = checkTextArry.join("");
      if (
        this.checkInfo.rootobject.tables &&
        this.checkInfo.rootobject.tables.length > 0
      ) {
        let textStr = "";
        let last_table_end_index = 0;
        this.checkInfo.rootobject.tables.forEach((table: any) => {
          let table_start_index = table[0][0].index;

          let table_end = table[table.length - 1][table[table.length - 1].length - 1];
          let str = this.checkTextStr.substring(last_table_end_index, table_start_index);
          textStr = textStr + this.markCheckText(str, last_table_end_index);

          last_table_end_index = table_end.index + table_end.length;
          textStr = textStr + this.drawTable(table);
        });
        if (last_table_end_index < this.checkTextStr.length) {
          textStr =
            textStr +
            this.markCheckText(
              this.checkTextStr.substring(last_table_end_index),
              last_table_end_index
            );
        }
        this.checkTextStr = textStr;
      } else {
        this.checkTextStr = this.markCheckText(this.checkTextStr, 0);
      }
      this.checkTextStr = this.checkTextStr
        .replace(//g, "<br />")
        .replace(/\r\n/g, "<br />")
        .replace(/\r/g, "<br />")
        .replace(/\n/g, "<br />");
    },

    drawTable(table: any) {
      const rows = table.length; // 行数
      let columns = 0; // 列数
      for (let i = 0; i < table.length; i++) {
        const row = table[i];
        if (Array.isArray(row) && row.length > columns) {
          columns = row.length;
        }
      }
      let header_index = table
        .map((row: any) => row[0])
        .findIndex((row: any, index: number) => {
          return row.text && index > 0;
        });
      let tempalte = `<div class="table-template">`;
      // table.forEach((row: any, index: number) => {
      //   if (index == header_index) {
      //     tempalte = tempalte + `<div class="flex table-header">`;
      //   } else {
      //     tempalte = tempalte + `<div class="flex">`;
      //   }
      //   row.forEach((item: any) => {
      //     tempalte =
      //       tempalte +
      //       `<div class="flex-auto">${this.markCheckText(item.text, item.index)}</div>`;
      //     // tempalte = tempalte + `<div class="flex-auto">${item.text}</div>`;
      //   });
      //   tempalte = tempalte + `</div>`;
      // });

      for (let index = 0; index < rows; index++) {
        if (index == header_index) {
          tempalte = tempalte + `<div class="flex table-header">`;
        } else {
          tempalte = tempalte + `<div class="flex">`;
        }

        for (let i = 0; i < columns; i++) {
          if (table[index][i]) {
            tempalte =
              tempalte +
              `<div class="flex-auto">${this.markCheckText(
                table[index][i].text,
                table[index][i].index
              )}</div>`;
          } else {
            tempalte = tempalte + `<div class="flex-auto"></div>`;
          }
        }
        tempalte = tempalte + `</div>`;
      }
      return tempalte + `</div>`;
    },
    markCheckText(text: string, text_start: number) {
      const indexArrays = this.checkInfo.hitDetailInfoList.map(
        (item: any) => item.originalChars
      );

      return this.highlightSubstring(text, indexArrays, text_start);
    },
    highlightSubstring(str: string, indexArrays: Array<any>, text_start: number) {
      const text_end = text_start + str.length;

      // Step 1: 收集所有全局下标（去重 + 有效范围预过滤可选）
      const globalIndices = new Set();
      for (const arr of indexArrays) {
        for (const idx of arr) {
          // 只保留可能影响当前片段的下标（可选优化）
          if (idx >= text_start && idx < text_end) {
            globalIndices.add(idx);
          }
        }
      }

      if (globalIndices.size === 0) return str;

      // Step 2: 排序并合并为全局连续区间
      const sorted = Array.from(globalIndices).sort((a: any, b: any) => a - b);
      const globalRanges = [];
      let start: any = sorted[0],
        end: any = sorted[0];

      for (let i = 1; i < sorted.length; i++) {
        if (sorted[i] === end + 1) {
          end = sorted[i];
        } else {
          globalRanges.push([start, end]);
          start = end = sorted[i];
        }
      }
      globalRanges.push([start, end]);

      // Step 3: 裁剪到 [text_start, text_end)，并转为局部区间
      const localRanges = [];
      for (const [s, e] of globalRanges) {
        const clipStart = Math.max(s, text_start);
        const clipEnd = Math.min(e, text_end - 1); // inclusive
        if (clipStart <= clipEnd) {
          localRanges.push([clipStart - text_start, clipEnd - text_start]);
        }
      }

      if (localRanges.length === 0) return str;

      // Step 4: 按局部区间高亮 str
      const parts = [];
      let lastEnd = 0;

      for (const [s, e] of localRanges) {
        if (s > lastEnd) {
          parts.push(str.slice(lastEnd, s));
        }
        parts.push(
          `<span  data_index="${s + text_start}" class="${this.applyHighlight(
            s + text_start
          )}">${str.slice(s, e + 1)}</span>`
        );
        lastEnd = e + 1;
      }

      if (lastEnd < str.length) {
        parts.push(str.slice(lastEnd));
      }

      return parts.join("");
    },
    applyHighlight(text_start: number) {
      let posToClass = "";

      for (const hitDetailInfo of this.checkInfo.hitDetailInfoList) {
        let eClass = "red border-b-red";
        if (hitDetailInfo.isSelfCited) {
          eClass = "yellow border-b-yellow";
        } else if (hitDetailInfo.isReference) {
          eClass = "green border-b-green";
        } else if (hitDetailInfo.isLaw) {
          eClass = "deepblue border-b-deepblue";
        }
        if (hitDetailInfo.originalChars.includes(text_start)) {
          posToClass = eClass;
          break;
        }
      }

      return posToClass;
    },
  },
  mounted() {
    if (this.checkInfo.hitDetailInfoList && this.checkText) {
      this.initOriginalTextMark();
    }
  },
});
